import { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import AccountDropdownSimplificationPage from "@faire/prototype-playground/workspace/shc/account-dropdown-simplification";
import { withCompass } from "../../components/compass/withCompass";

const BrandsOnFairePage = withCompass(
  () => import("../../pages/BrandsOnFairePage")
);
const ProgressiveModalsInsiderPage = withCompass(
  () => import("../../pages/ProgressiveModalsInsiderPage")
);

export function SharonChanRoutes() {
  return (
    <Switch>
      <Route path="/shc/account-dropdown-simplification" component={AccountDropdownSimplificationPage} />
      <Route
        path="/shc/progressive-modals-insider"
        component={ProgressiveModalsInsiderPage}
      />
      <Route path="/shc/brands-on-faire" component={BrandsOnFairePage} />
    </Switch>
  );
}

export const slug = "shc";
